import { ErrorContent } from '../../components/layouts'

export default function SystemError() {
  return <ErrorContent
    title='System Error'
    subtitle='システム内部でエラーが発生しました'
    message='ホーム画面に戻ってやり直すか、システム管理者に連絡してください。'
    returnToHome={true} />
}
